/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import axios from 'axios';
import urlJoin from 'proper-url-join';

import { StoreQueryParams } from '../../../../ts';
import { AssistantPreferencesWithId } from '../../../../ts/preferences';
import { endpoints } from '../../util/config';

const assistantPreferencesEndpoint = (assistantId: string): string =>
  urlJoin(`${endpoints.store}/preferences/assistants`, assistantId);

const auditParams: StoreQueryParams = {
  include_audit: true,
  verbose: true
};

const postAuditParams: StoreQueryParams = {
  include_audit: true,
  verbose: true
};

export const listAssistantPreferences = async (
  assistantId: string,
  params: StoreQueryParams = {}
): Promise<AssistantPreferencesWithId> => {
  const url = assistantPreferencesEndpoint(assistantId);
  const response = await axios.get(url, {
    params: { ...auditParams, ...params }
  });
  return response.data;
};

export const setAssistantPreferences = async (
  assistantId: string,
  preferences: any,
  params: StoreQueryParams = {}
): Promise<AssistantPreferencesWithId> => {
  const response = await axios.post(
    assistantPreferencesEndpoint(assistantId),
    { preferences },
    {
      params: { ...postAuditParams, ...params }
    }
  );
  return response.data;
};
